import React from "react";
import ReactDOM from "react-dom/client";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import App from "./App";
import "./styles.css";

Office.onReady(() => {
  // Word may restore its remembered pane width after Office.onReady, overriding
  // the first resize. Reassert the same fixed width after startup settles.
  // Older clients without TaskPaneApi 1.1 keep their host-controlled width.
  if (Office.context.requirements.isSetSupported("TaskPaneApi", "1.1")) {
    const taskpane = Office.extensionLifeCycle.taskpane;
    const setFixedPaneWidth = () => taskpane.setWidth(670);
    setFixedPaneWidth();
    window.setTimeout(setFixedPaneWidth, 500);
    window.setTimeout(setFixedPaneWidth, 1500);
  }

  ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
      <FluentProvider theme={webLightTheme}>
        <App />
      </FluentProvider>
    </React.StrictMode>
  );
});
